import React from 'react';

import './Page.css';


class PageTest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

  }
  

  render() {

    return (
          
    <main className='pages-body'>
        <section className='pages-section responsive-text'>
            <h2>Introduction</h2>
            <p>This API allows you to access various resources and services provided by our platform. Below, we explain the usage, parameters, and provide examples.</p>
        </section>

        <section className='pages-section responsive-text'>
            <h2>Endpoint Overview</h2>
            <p>To interact with our API, hit the following endpoint:</p>
            <code class="endpoint">GET https://api.example.com/resource</code>
        </section>

        <section className='pages-section responsive-text'>
            <h2>Request Parameters</h2>
            <p>The following parameters can be included in your request:</p>
            <ul>
                <li><strong>param1:</strong> Description of param1.</li>
                <li><strong>param2:</strong> Description of param2.</li>
            </ul>
        </section>

        <section className='pages-section responsive-text'>
            <h2>Example Request and Response</h2>
            <p>Here’s a sample of the JSON data you can expect as a response:</p>
            <pre><code class="json">&#123;
    "data": &#123; <br/>
        "id": 1,<br/>
        "name": "Example Resource",<br/>
        "description": "This is an example of a resource."<br/>
    &#125;,
    "status": "success"
&#125;</code></pre>

            <p>Below is an example of how to make a request using Python:</p>
            <pre><code class="python">import requests

url = "https://api.example.com/resource"
params = &#123;
    'param1': 'value1',
    'param2': 'value2'
&#125;

response = requests.get(url, params=params)
data = response.json()
print(data)</code></pre>
        </section>
    </main>
          
    )
  }
}

export default PageTest;
